import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.529}
    height={26.089}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 9604 16135"
    {...props}
  >
    <path
      d="M5347 625 1399 10859c-74 189-288 285-478 212-190-74-873-327-799-517L4070 321c74-190 876-246 1066-173 189 73 285 287 211 477zM4052 14455h3554c1439-2512 1924-4580 1879-6039-51-1640-760-3988-2482-6268-327 2082-706 3991-1393 6060-351 2153-871 4306-1697 6247h139zM6211 1159l-3878 9738c341 939-48 1870-486 2868-60 137-275 414-213 553 61 138 299 136 454 136l1119 1c473-2153 971-4290 1495-6411 550-2227 1128-4434 1735-6621-193-232-13-41-226-264zm713 6956-419 1824c-22 95-118 154-212 133l-164-38c-236 1053-457 2036-556 2476-38 170 1121 941 1255 685 859-1639 1252-3411 1259-4507 7-1095-1037-2691-1126-2298l-338 1474 169 39c95 22 154 117 132 212zm361 6818v1086l-694-1v-1085h694z"
      style={{
        // fill: "#1c1b17",
        // stroke: "#1c1b17",
        strokeWidth: 233.759,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
